import { ChoseEntityButton } from '@bit/wavfichacerta.fichacerta.shared-styles.buttons';
import { MainContainer } from '@bit/wavfichacerta.fichacerta.shared-styles.containers';
import { StyledRow } from '@bit/wavfichacerta.fichacerta.shared-styles.rows';
import styled, { css } from 'styled-components';

export const StyledChoseEntityButton = styled(ChoseEntityButton)`
  display: inline-block;
  border-color: rgba(21, 43, 78, 0.24);
  background-color: #fff;
  border-radius: 10px;
  padding: 0.45rem 1.15rem;
  transform: none;
  font-size: .8rem;
  font-weight: 600;
  letter-spacing: .03em;
  text-transform: uppercase;
  min-height: 38px !important;
  width: 11.2rem !important;
  margin: 0 0 14px 0 !important;
  color: #152b4e;
  box-shadow: 0 1px 2px rgba(21, 43, 78, 0.08);
  transition: all 0.18s ease;

  &:hover {
    color: #fff;
    background: linear-gradient(180deg, #1a3d66 0%, #152b4e 55%, #122845 100%);
    border-color: #152b4e;
    transform: translateY(-1px);
    box-shadow: 0 4px 14px rgba(21, 43, 78, 0.2);
  }

  ${props => css`${props.selected &&
    `
    color: #fff;
    background: linear-gradient(180deg, #1a3d66 0%, #152b4e 55%, #122845 100%);
    border-color: #152b4e;
    cursor: default;
    box-shadow: 0 4px 14px rgba(21, 43, 78, 0.2);
    `
  }`}

  ${props => css`${props.styles}`};
`;

/** Conteúdo interno da escolha de produto (evita styled(Fragment), que não ancora layout no DOM). */
export const EntityChoiceBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  width: 100%;
  flex: 0 0 auto;
`;

export const StyledMainContainer = styled(MainContainer)`
  padding: .85rem 0 0 0 !important;
  width: calc(100% - 24px);
  max-width: 980px;
  margin: 8px auto 0 !important;
  display: block !important;
  height: auto !important;
  position: relative !important;
  top: 0 !important;
  transform: none !important;
  min-height: auto !important;
  flex: 0 0 auto;
  align-self: center;
  align-items: initial !important;
  justify-content: initial !important;
  background: #fff;
  border: 1px solid rgba(21, 43, 78, 0.08);
  border-radius: 14px;
  box-shadow: 0 8px 28px rgba(21, 43, 78, 0.08);
  ${(props) => css`${props.styles}`};

  @media (max-width: 800px) {
    top: 0 !important;
    margin: 12px auto 0 !important;
    padding: 16px 10px 12px !important;
    width: 100%;
    max-width: 100%;
    border-radius: 12px;
    align-self: stretch;
  }
`;

export const StyledRowComponent = styled(StyledRow)`
  padding: 0 0 .75rem 0 !important;
  ${props => css`${props.styles}`};

  @media (max-width: 800px){
    padding: 0 0 .7rem 0 !important;
  }
`;

